import { __decorate, __metadata, __param } from "tslib";
import { fetchFamily } from '@gn-audio/core/api/product-catalogue/fetch-family';
import { Component, Inject, Input } from 'angular-ts-decorators';
import template from './eol-info-spot.component.html';
var EolInfoComponent = (function () {
    function EolInfoComponent($q) {
        this.$q = $q;
    }
    EolInfoComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.$q
            .when(fetchFamily(this.familyId, "supported"))
            .then(function (family) {
            _this.suggestedProduct = family;
        });
    };
    EolInfoComponent.$inject = ['$q'];
    __decorate([
        Input('@'),
        __metadata("design:type", Number)
    ], EolInfoComponent.prototype, "familyId", void 0);
    EolInfoComponent = __decorate([
        Component({
            selector: 'eolInfoSpot',
            template: template,
        }),
        __param(0, Inject('$q')),
        __metadata("design:paramtypes", [Function])
    ], EolInfoComponent);
    return EolInfoComponent;
}());
export { EolInfoComponent };
